import React from 'react';
import './List.scss';

export default ({ title, description, children, className = "" }) => (
    <div className={`list-container ${className}`}>
        {title ? <h2 className="list-title">{title}</h2> : null}
        {description ? <p className="list-description">{description}</p> : null}
        {Array.isArray(children) ? children.map((element, index) => <div key={index} className="list-item-container">{element}</div>) : children}
    </div>
)